import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';

export function AuthError() {
  const { t } = useCopy();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          {t('auth.errorTitle', 'Sign-in could not be completed')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t('auth.errorBody', 'Your session could not be restored. Try signing in again.')}
        </Typography>
        <Box>
          <Button variant="contained" onClick={() => redirectToCentralizedLogin('/')}>
            {t('auth.tryAgain', 'Try again')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
